import {ApiGet, ApiPatch, ApiPost, ApiPostRaw} from "../../../shared/services/api-service";
import {mergeTasksWithResponses, normazileTaskResponses} from "../../../shared/services/utils/tasks";
import taskTrainingCommitTypes from "./commit-types";
import {normalizeTaskResponseResources} from "../../../shared/services/utils/utils";

const taskTrainingActionCreators = {
  fetchTaskTraining(oitGuid) {
    return (dispatch) => {
      return Promise.all([
        ApiGet(`/api/v1/oits/${oitGuid}/task-groups-training-trackers`),
        ApiGet(`/api/v1/oits/${oitGuid}/task-responses`)
      ])
        .then(([taskGroups, taskResponses]) => {
          dispatch({
            type: taskTrainingCommitTypes.SET_TASK_TRAINING,
            oitGuid: oitGuid,
            taskTraining: mergeTasksWithResponses(taskGroups, taskResponses)
          })
        })
    }
  },

  fetchOitTaskResponses() {
    return (dispatch) => {
      return ApiGet(`/api/v1/tasks-to-oit-acknowledge`)
        .then((taskResponses) => {
          dispatch({
            type: taskTrainingCommitTypes.SET_MY_TASK_RESPONSES,
            myTaskResponses: normazileTaskResponses(taskResponses)
          })
        })
    }
  },

  fetchMyTaskResponses(oitGuid) {
    return (dispatch) => {
      return ApiGet(`/api/v1/oits/${oitGuid}/task-responses`)
        .then((taskResponses) => {
          dispatch({
            type: taskTrainingCommitTypes.SET_MY_TASK_RESPONSES,
            myTaskResponses: normazileTaskResponses(taskResponses)
          })
        })
    }
  },

  updateReferenceMaterialResponses(data) {
    return (dispatch) => {
      return ApiPostRaw('/api/v1/task-group-reference-responses', data)
        .then((res) => {
          dispatch({
            type: taskTrainingCommitTypes.UPDATE_TASK_TRAINING,
            guid: data.guid,
            oitGuid: data.oitGuid,
            reference_responses: res.reference_responses
          });
        })
    }
  },

  addResponses(oitGuid, taskGuid, actions, actionAt, authorComment, substandard) {
    return (dispatch) => {
      return Promise.all(actions.map(action => ApiPost('/api/v1/task-response', {
        oitGuid,
        taskGuid,
        action,
        actionAt,
        authorComment,
        substandard
      })))
        .then(tr => tr.reduce((acc, t) =>
          [
            ...acc,
            ...(Array.isArray(t)? t: [t])
          ],[]))
        .then(tr => {
          let taskResponses = normalizeTaskResponseResources(tr);

          dispatch({
            type: taskTrainingCommitTypes.ADD_TASK_RESPONSES,
            taskResponses,
            taskGuid,
            oitGuid
          });

          return taskResponses
        })
    }
  },

  ackResponse(taskResponseGuid, oitComment, oitGuid) {
    console.log(taskResponseGuid, oitComment, oitGuid)
    return (dispatch) => {
      let acknowledgedAt =  (new Date).toISOString();
      return ApiPost('/api/v1/task-response/acknowledge', {
        taskResponseGuid,
        acknowledgedAt,
        oitComment
      })
        .then(tr => {
          dispatch({
            type: taskTrainingCommitTypes.SET_TASK_RESPONSE_ACK,
            taskResponseGuid,
            oitGuid,
            acknowledgedAt,
            ackComment: oitComment
          })
        })
    }
  },

  submitResponse(taskResponseGuid, oitGuid, taskGuid, action) {
    return (dispatch) => {
      return ApiPatch('/api/v1/task-response', {
        taskResponseGuid,
        status: 'submitted'
      })
        .then(tr => {
          dispatch({
            type: taskTrainingCommitTypes.SET_TASK_RESPONSE_STATUS,
            taskResponseGuid,
            taskGuid,
            oitGuid,
            status: 'submitted'
          })
        })
    }
  },

  rejectResponse(data) {
    return (dispatch) => {
      return ApiPost('/api/v1/task-response/reject', data)
        .then(tr => {
          console.log(tr)
          dispatch({
            type: taskTrainingCommitTypes.REJECT_TASK_RESPONSE,
            taskResponseGuid: data.taskResponseGuid,
            taskGuid: data.taskGuid,
            oitGuid: data.oitGuid,
            rejectedBy: tr.attributes.rejectedBy,
            rejectedAt: tr.attributes.rejectedAt,
            rejectComment: tr.attributes.rejectComment,
            status: 'rejected'
          })
        })
    }
  },

  updateResponse(taskResponseGuid, oitGuid, taskGuid, action, actionAt, authorComment, substandard) {
    return (dispatch) => {
      return ApiPatch('/api/v1/task-response', {
        taskResponseGuid,
        status: 'draft'
      }).then(() => ApiPatch('/api/v1/task-response', {
        taskResponseGuid,
        action,
        actionAt,
        authorComment,
        substandard
      })
        .then(tr => {
          dispatch({
            type: taskTrainingCommitTypes.UPDATE_TASK_RESPONSE,
            taskResponseGuid,
            taskGuid,
            oitGuid,
            action,
            actionAt,
            authorComment,
            substandard,
            status: 'draft'
          })
        }))
    }
  }
};

export default taskTrainingActionCreators;
